class FilterItemSK {
    constructor(parent, el) {
		this._init(parent, el)
	}
	_init(parent, el) {
        this.parent = parent
        this.root = el
        this.root.addEventListener('click', ev => {
            if (this.parent.activesRoot.querySelector('[data-filter="'+ el.dataset.filter +'"]')) {
                return
            }
            if ('filterSort' in el.dataset && this.parent.activesRoot.querySelector('[data-filter-sort]')) {
                this.parent.activesRoot.querySelector('[data-filter-sort]').remove()
            }
            if ('filterColor' in el.dataset && this.parent.activesRoot.querySelector('[data-filter-color]')) {
                this.parent.activesRoot.querySelector('[data-filter-color]').remove()
            }
            if ('filterPrice' in el.dataset && this.parent.activesRoot.querySelector('[data-filter-price]')) {
                this.parent.activesRoot.querySelector('[data-filter-price]').remove()
            }
            this.parent.addToActives(this.root)
        })
    }
}

class FilterItemActiveSK {
    constructor(parent, el) {
		this._init(parent, el)
	}
	_init(parent, el) {
        this.parent = parent
        this.root = el
        this.root.addEventListener('click', ev => {
            this.root.remove()
            this.parent.updateActives()
        })
    }
}

class FiltersSK {
	constructor(parent) {
		this._init()
	}

	_init() {
        this.firstTimeRun = true
        this.root = document.querySelector('[data-filter-manager]')
        if (!this.root) {
            return
        }

        this.hideOptionsNotInUseFilters()

        this.activesRoot = this.root.querySelector('[data-filter-actives]')
        if (!this.activesRoot) {
            return
        }

        this.activesContent = this.activesRoot.querySelector('[data-filter-actives-content]')
        if (!this.activesContent) {
            return
        }

        this.resetElement = this.activesRoot.querySelector('[data-filter-reset]')
        if (this.resetElement) {
            this.resetElement.addEventListener('click', ev => {
                this.activesContent.innerHTML = '';
                this.updateActives()
            })
        }

        this.root.querySelectorAll('[data-filter-options] [data-filter]').forEach(el => {
            new FilterItemSK(this, el)
        })

        this.updateActives()
	}

    addToActives(el) {
        const newEl = el.cloneNode(true)
        new FilterItemActiveSK(this, newEl)
        this.activesContent.appendChild(newEl)
        this.updateActives()
    }

    hideOptionsNotInUseFilters() {
        let options = []
        document.querySelectorAll('[data-product]').forEach(el => {
            if (el.dataset.color && "" != el.dataset.color) {
                options = options.concat(el.dataset.color.split(','))
            }
            if (el.dataset.size && "" != el.dataset.size) {
                options = options.concat(el.dataset.size.split(','))
            }
            if (el.dataset.price && "" != el.dataset.price) {
                options = options.concat(el.dataset.price)
            }
        })

        this.root.querySelectorAll('[data-filter]').forEach(el => {
            if ('filterSort' in el.dataset) {
                return
            }
            if (options.includes(el.dataset.filter)) {
                el.style.display = ''
            } else {
                el.remove()
            }
        })

        this.root.querySelectorAll('[data-filter-options]').forEach(el => {
            if (el.childElementCount < 1) {
                el.parentElement.remove()
            }
        })
    }

    filterProducts() {
        if (this.firstTimeRun) {
            this.firstTimeRun = false
            return
        }

        let optionsActiveSort = ''
        let optionsActiveSize = []
        let optionsActiveColor = []
        let optionsActivePrice = []

        this.activesContent.querySelectorAll('[data-filter-sort][data-filter]').forEach(el => {
            optionsActiveSort = el.dataset.filter
        })

        this.activesContent.querySelectorAll('[data-filter-size][data-filter]').forEach(el => {
            optionsActiveSize.push(el.dataset.filter)
        })

        this.activesContent.querySelectorAll('[data-filter-color][data-filter]').forEach(el => {
            optionsActiveColor.push(el.dataset.filter)
        })

        this.activesContent.querySelectorAll('[data-filter-price][data-filter]').forEach(el => {
            optionsActivePrice.push(el.dataset.filter)
        })

        document.querySelectorAll('[data-products]').forEach(el => {
            el.style.opacity = "0"
            el.style.transition = "opacity 0.3s"
        })

        setTimeout(() => {
            const list = document.querySelector('[data-products]');
            [...list.children]
                .sort((a,b)=> {
                    if ("a-z" === optionsActiveSort) {
                        return a.dataset.productName > b.dataset.productName ? 1 : -1
                    } else if ("z-a" === optionsActiveSort) {
                        return b.dataset.productName > a.dataset.productName ? 1 : -1
                    } else if ("price-low-high" === optionsActiveSort) {
                        return parseInt(a.dataset.productPrice) - parseInt(b.dataset.productPrice)
                    } else if ("price-high-low" === optionsActiveSort) {
                        return parseInt(b.dataset.productPrice) - parseInt(a.dataset.productPrice)
                    }
                    return parseInt(a.dataset.product) - parseInt(b.dataset.product)
                })
                .forEach(node=>list.appendChild(node))

            document.querySelectorAll('[data-product]').forEach(el => {
                const options = [].concat(el.dataset.color.split(','))
                if (0 === optionsActiveColor.length || optionsActiveColor.every(r => options.includes(r))) {
                    el.style.display = ''
                } else {
                    el.style.display = 'none'
                }
            })

            document.querySelectorAll('[data-product]:not([style*="display: none"])').forEach(el => {
                const options = [].concat(el.dataset.size.split(','))
                if (0 === optionsActiveSize.length || optionsActiveSize.every(r => options.includes(r))) {
                    el.style.display = ''
                } else {
                    el.style.display = 'none'
                }
            })

            document.querySelectorAll('[data-product]:not([style*="display: none"])').forEach(el => {
                const options = [].concat(el.dataset.price.split(','))
                if (0 === optionsActivePrice.length || optionsActivePrice.every(r => options.includes(r))) {
                    el.style.display = ''
                } else {
                    el.style.display = 'none'
                }
            })

            if (0 === document.querySelectorAll('[data-product]:not([style*="display: none"])').length) {
                document.querySelectorAll('[data-empty]').forEach(el => el.classList.add('collection__empty--is-show'));
            } else {
                document.querySelectorAll('[data-empty]').forEach(el => el.classList.remove('collection__empty--is-show'));
            }

            document.querySelectorAll('[data-products]').forEach(el => {
                el.style.opacity = "1"
            })
        }, 400)
    }

    updateActives() {
        if (this.activesContent.childElementCount > 0) {
            this.resetElement.style.display = 'flex';
        } else {
            this.resetElement.style.display = 'none';
        }
        this.filterProducts()
    }
}

export default FiltersSK
